import { render, staticRenderFns } from "./ListItemAdjModal.vue?vue&type=template&id=2b8560e4&scoped=true&"
import script from "./ListItemAdjModal.vue?vue&type=script&lang=js&"
export * from "./ListItemAdjModal.vue?vue&type=script&lang=js&"
import style0 from "./ListItemAdjModal.vue?vue&type=style&index=0&id=2b8560e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8560e4",
  null
  
)

export default component.exports